import { useCallback, useMemo } from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import { STATUS_COLORS, STATUS_ICONS } from '../constants';

export const useStatusRender = () => {
  return useMemo(() => {
    return (status: string) => {
      const statusConfigs: {
        [key: string]: { color: string; icon: React.ReactNode; text: string };
      } = {
        ACTIVE: {
          color: 'success',
          icon: <CheckCircleOutlined />,
          text: 'Active',
        },
        INACTIVE: {
          color: 'default',
          icon: <StopOutlined />,
          text: 'Inactive',
        },
      };

      const config = statusConfigs[status] || {
        color: 'default',
        icon: <StopOutlined />,
        text: status,
      };

      return (
        <Tag color={config.color} icon={config.icon}>
          {config.text}
        </Tag>
      );
    };
  }, []);
};
